import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "estimates-received-main tw-h-full tw-w-full tw-pb-2 tw-box-border" }

import RequestedEstimateReceivedPreview from "@/modules/project/components/screens/RequestedEstimateReceivedPreview.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RequestedProjectEstimate',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RequestedEstimateReceivedPreview, {
      estimateId: Number(_ctx.$route.params?.estimateId)
    }, null, 8, ["estimateId"])
  ]))
}
}

})